import styled from "styled-components";

export const OptionFormContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
`;
